(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-wholesale-form"]) return;
  try {
    
/* custom-wholesale-form */
  var wholesale_css = `[data-testid="app-router"]:not(#id) [data-sizing="form-wrapper"] { margin: 0px; width: 100%; max-width: 100%; }

    [data-testid="banner-success"]:not(#id) { margin-top: 0; }
    [data-sizing="form-wrapper"] section[class*="_formHeader"] { margin: 0px 0px 2.4rem; }

    section[class*="_formHeader"]:not(#id) h2,
    [data-testid="banner-success"]:not(#id) h2 { font-size: 2.4rem; line-height: 1.2; font-family: var(--font-heading-family); font-weight: var(--font-heading-weight); }

    [data-testid="form"] [class*="_textBody"], 
    [data-testid="form"] [class*="_textBody"] p {
      font-weight: var(--font-medium-weight); font-family: inherit; font-size: 1.6rem; line-height: var(--font-body-line-height); }

    [data-sizing="form-wrapper"]:not(#id) form { gap: 1.6rem; padding: 0; flex-wrap: wrap; flex-direction: row; }
    [data-sizing="form-wrapper"]:not(#id) form>[class*="_formFieldContainer"],
    [data-sizing="form-wrapper"]:not(#id) form>fieldset[class*="_checkboxFieldSet"] { width: 100%; }    

    [class*="_formFieldContainer"][class*="_withError"] + output[class*="_formError"] { margin-top: -1rem; margin-left: 2.4rem; }

      input[class*="_formInputField"]:not(#id),
      input[class*="_formPhoneInputField_"]:not(#id) { box-shadow: none; border-radius: 100px; background: rgba(35, 31, 32, 0.03); padding: 1.5rem 2.4rem; }

      [class*="_formFieldContainer"]:focus-within [class*="_formInputFieldLabel_"]:not(#id),
      label[class*="_inputFilled"]:not(#id) { opacity: 0; }
      label[class*="_formInputFieldLabel"]:not(#id) { left: 2.4rem; }

      [class*="_formPhoneInputContainer"]:not(#id) { gap: 1.6; grid-template-columns: 9.8rem minmax(0, 2.2fr); }
        [class*=_selectToggle_][aria-controls="country-selector-dropdown"] { width: 9.8rem; border-radius: 10rem; box-shadow: none; padding: 1.5rem 2.4rem; background: rgba(35, 31, 32, 0.03); }
        [class*=_selectToggle_][aria-controls="country-selector-dropdown"] [class*="_selectToggleText_"] { width: 2.4rem; height: 1.8rem; }
        [class*=_selectToggle_][aria-controls="country-selector-dropdown"] img { width: 2.4rem; height: 1.8rem; } 
        [class*=_selectToggle_][aria-controls="country-selector-dropdown"] [class*="_arrowDownIcon"] { margin-right: -0.9rem; }
        [class*=_selectToggle_][aria-controls="country-selector-dropdown"] [class*="_arrowDownIcon"] svg { display: block; }

      [data-testid="form"] fieldset[class*="_checkboxFieldSet"]>div label,
      [data-testid="form"] fieldset[class*="_checkboxFieldSet"] legend { font-size: calc(var(--font-body-scale) * 1rem); font-weight: var(--font-semi-bold-weight); line-height: var(--font-body-line-height); font-family: inherit; }

        fieldset[class*="_checkboxFieldSet"]>div { gap: 0.8rem; }
        fieldset[class*="_checkboxFieldSet"]>div label { text-align: center; padding: 1.15rem 0.4rem; border-radius: 10rem; border: 1px solid rgba(35, 31, 32, 0.15); position: relative; grid-template-columns: unset; gap:0; }
        fieldset[class*="_checkboxFieldSet"]>div label input { -webkit-appearance: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 1px solid rgba(35, 31, 32, 0.15); border-radius: 10rem; }
        fieldset[class*="_checkboxFieldSet"]>div label input:checked { border-color: var(--forms-accent-color); }
        fieldset[class*="_checkboxFieldSet"]>div label input:checked + span:not(#id) { font-weight: var(--font-semi-bold-weight); }

      [class*="_formSubmitButton"][data-testid="btn-form-submit"] { padding: 1.5rem 3rem; font-size: calc(var(--font-body-scale) * 1rem); letter-spacing: 0.05em; font-weight: var(--font-semi-bold-weight); text-transform: uppercase; border-radius: 10rem; margin-top: 1rem; }
      [class*="_formSubmitButton"][data-testid="btn-form-submit"]:hover { background: rgb(var(--color-default-hover)); }      

      @media (min-width: 990px){
        [data-testid="banner-success"]:not(#id) { margin-top: 0; }
        [data-sizing="form-wrapper"] section[class*="_formHeader"] { margin-bottom: 0px 0px 2rem; }

        [data-sizing="form-wrapper"]:not(#id) form { gap: 2rem; }
        [class*="_formPhoneInputContainer"]:not(#id) { gap: 2rem 3rem; }

        section[class*="_formHeader"]:not(#id) h2,
        [data-testid="banner-success"]:not(#id) h2 { font-size: 3.5rem; }
      }
    `;

  document.addEventListener('DOMContentLoaded', function () {
    const wholesale_shadow = document.querySelector('.shopify-app-block [data-forms-id]');
    let count = 0;
    
    function callItself(){      
      if( wholesale_shadow.querySelector('form-embed') ){
        const formEmbed = wholesale_shadow.querySelector('form-embed');

        const style = document.createElement("style");
        style.innerHTML = wholesale_css;        
        formEmbed
        .shadowRoot
        .append(style);
        count = 11;
      }else{
        setTimeout(() => {
          count += 1;
          if( count < 10 ){
            callItself();
          }
        }, 1000);
      }      
    }
    callItself();
     
  });
/* custom-wholesale-form */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();
			const tis = this;
			const cart_item = document.querySelector('cart-items');
			this.querySelector('button').addEventListener(
				'click',
				debounce((event) => {
					tis.querySelector('.loading-overlay').classList.remove('hidden');
					document.body.classList.add('cart--loading');
					let rendersection = {
						note: event.target.closest('div').querySelector('textarea').value,
            sections: document.querySelector('cart-items').getSectionsToRender().map((e => e.section)),
            sections_url: window.location.pathname
          };
					const body = JSON.stringify(rendersection);
					fetch(`${routes.cart_update_url}`, { 
						...fetchConfig(), ...{ body } 
					}).then((e => e.text())).then((t => {
						const parsedState = JSON.parse(t)
            cart_item.getSectionsToRender().forEach((section) => {
							const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);							
							elementToReplace.innerHTML = cart_item.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
						})
         })).catch(((e) => {
            console.log('cartnote error', e);
            document.body.classList.remove('cart--loading');
         })).finally((() => {            
            console.log('finally cartnote');
						tis.querySelector('.loading-overlay').classList.add('hidden');
						document.body.classList.remove('cart--loading');
         }));
				}, 300)
			);
			// 	this.addEventListener(
			// 		'change',
			// 		debounce((event) => {
			// 			const body = JSON.stringify({ note: event.target.value });
			// 			fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
			// 		}, 300)
			// 	);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);      

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }

      if( this.querySelector('.product-media-modal__content:not(.swiper-initialized)') ){
        const remove_selected = this.querySelector('.product-media-modal__content:not(.swiper-initialized) .product-media-modal__item.selected');
        if( remove_selected ){
          remove_selected.classList.remove('selected');
        }
        activeMedia.closest('.product-media-modal__item').classList.add('selected');
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
